import React from 'react';
import { Collapse, List, Space, Typography } from 'antd';
import { ToolOutlined } from '@ant-design/icons';

const { Panel } = Collapse;
const { Text } = Typography;

const formatConfigKey = (key) => {
    if (typeof key !== 'string') return key;
    return key.replace(/_/g, ' ').replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase());
};

const LessonConfigurationCard = ({ configData, defaultOpen = false }) => {
    if (!configData || configData.length === 0) {
        return null;
    }

    return (
        <div id="lesson-configuration">
            <Collapse expandIconPosition="end" defaultActiveKey={defaultOpen ? ['config'] : []}>
                <Panel
                    header={<Space><ToolOutlined /> Lesson Plan Configuration</Space>}
                    key="config"
                >
                    <List
                        grid={{
                            gutter: 16,
                            xs: 1,
                            sm: 2,
                            md: 2,
                            lg: 2,
                            xl: 2,
                            xxl: 2,
                        }}
                        dataSource={configData}
                        renderItem={item => (
                            <List.Item>
                                <List.Item.Meta
                                    title={<Text strong>{item.title}</Text>}
                                    description={typeof item.value === 'string' ? <Text>{formatConfigKey(item.value)}</Text> : item.value}
                                />
                            </List.Item>
                        )}
                    />
                </Panel>
            </Collapse>
        </div>
    );
};

export default LessonConfigurationCard;
